export default __webpack_public_path__ + "static/media/made-in-europe-000000.fdc5fa6d.png";